import React from 'react'
import actions from 'redux/actions'

import OrderItem from 'components/cart/OrderItem/OrderItem'


const handleRemove = (item) => actions.models.cart.removeProduct(item)
const handleIncreaseCount = (item) => actions.models.cart.increaseItemCount(item)
const handleDecreaseCount = (item) => actions.models.cart.decreaseItemCount(item)

const CartProduct = ({ className, data, isCounterVisible, isRemoveVisible }) => (
  <OrderItem
    className={className}
    data={data}
    isCounterVisible={isCounterVisible}
    isRemoveVisible={isRemoveVisible}
    onDecreaseCount={handleDecreaseCount}
    onIncreaseCount={handleIncreaseCount}
    onRemove={handleRemove}
  />
)


export default React.memo(CartProduct)
